import { useMemo } from 'react';
import { KPICard } from '../ui/KPICard';
import { formatBR } from '../../lib/utils';
import type { ServiceInfo } from '../../lib/types';

export interface ServiceStatsStripProps {
  services: ServiceInfo[];
  accent: string;
  machinesTotal?: number;
  machinesUsed?: number;
}

export function ServiceStatsStrip({
  services,
  accent,
  machinesTotal = 0,
  machinesUsed = 0,
}: ServiceStatsStripProps) {
  const stats = useMemo(() => {
    let running = 0;
    let replicas = 0;
    for (const s of services) {
      running += s.machines;
      replicas += s.replicas;
    }
    return { running, replicas };
  }, [services]);

  const machinesFree = Math.max(0, machinesTotal - machinesUsed);

  return (
    <div
      className="grid grid-cols-3 gap-px overflow-hidden rounded-lg border border-border bg-border"
      data-testid="service-stats-strip"
    >
      <KPICard
        label="Máquinas Disponíveis"
        value={
          machinesTotal > 0
            ? `${formatBR(machinesFree)}/${formatBR(machinesTotal)}`
            : '—'
        }
        sub="livres para escalar"
        color={accent}
      />
      <KPICard
        label="Tasks Running"
        value={formatBR(stats.running)}
        sub="instâncias ativas"
        color="#15803d"
      />
      <KPICard
        label="Total Réplicas"
        value={formatBR(stats.replicas)}
        sub="configuradas"
        color="#b45309"
      />
    </div>
  );
}

ServiceStatsStrip.displayName = 'ServiceStatsStrip';

export default ServiceStatsStrip;
